export default "__VITE_ASSET__COxSbiKK__"